import { apiInstance } from '../api';

const usersRoute = '/users'

export class UsersService {

  // what the current user's roles allow
  static async fetchAccess() {
    return apiInstance.get(`${usersRoute}/me/access`)
  }

  static async fetchUsers() {
    return apiInstance.get(usersRoute)
  }

  // search, role, status (active | blocked), sort, page, limit
  static async fetchAdminList(params) {
    return apiInstance.get(`${usersRoute}/admin/list`, { params })
  }

  static async createUser(userInfo) {
    return apiInstance.post(usersRoute, userInfo );
  }

  static async updateUser(userId, userInfo) {
    return apiInstance.put(`${usersRoute}/${userId}`, userInfo)
  }

  static async deleteUser(userId) {
    return apiInstance.delete(`${usersRoute}/${userId}`);
  }

  static async blockUser(userId, reason) {
    return apiInstance.put(`${usersRoute}/${userId}/block`, { reason })
  }

  static async unblockUser(userId) {
    return apiInstance.put(`${usersRoute}/${userId}/unblock`)
  }

  static async setPassword(userId, password) {
    return apiInstance.put(`${usersRoute}/${userId}/password`, { password })
  }

  static async setRoles(userId, roleIds) {
    return apiInstance.put(`${usersRoute}/${userId}/roles`, { roleIds })
  }

}
